var _defs, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhpunit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 15.996,
    y1: 2.953,
    x2: 15.996,
    y2: 29.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    stopColor: "#838fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#8b96ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#99a2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#adb2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#c7c8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#cecdff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_phpunit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.265,30a2.6,2.6,0,0,1-.889-.157L3.731,23.8a2.617,2.617,0,0,1-1.566-3.358L8.273,3.719a2.621,2.621,0,0,1,3.351-1.562L28.27,8.2a2.617,2.617,0,0,1,1.566,3.358l-.525,1.437a1.157,1.157,0,0,1-.888.748,1.138,1.138,0,0,1-1.077-.379,3.507,3.507,0,0,0-2.667-1.2h-.013a3.39,3.39,0,0,0-3.446,3.322,3.389,3.389,0,0,0,3.456,3.3h.013a3.618,3.618,0,0,0,.672-.065,1.129,1.129,0,0,1,1.087.384,1.172,1.172,0,0,1,.209,1.16l-2.932,8.028A2.623,2.623,0,0,1,21.265,30ZM10.734,2.872A1.749,1.749,0,0,0,9.093,4.018L2.984,20.746a1.745,1.745,0,0,0,1.044,2.238l16.646,6.038a1.747,1.747,0,0,0,2.234-1.042l2.932-8.028a.3.3,0,0,0-.054-.295.264.264,0,0,0-.258-.093,4.5,4.5,0,0,1-.835.081h-.016a4.262,4.262,0,0,1-4.328-4.167,4.263,4.263,0,0,1,4.315-4.2h.016a4.379,4.379,0,0,1,3.328,1.508.273.273,0,0,0,.26.09.291.291,0,0,0,.225-.189l.525-1.436a1.745,1.745,0,0,0-1.044-2.239L11.327,2.977A1.735,1.735,0,0,0,10.734,2.872Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.678,17.5a2.035,2.035,0,0,1-.007-4.071,2,2,0,0,1,1.441.591,2.036,2.036,0,0,1-1.427,3.48h-.007Zm0-3.053h0a1.018,1.018,0,0,0,0,2.035h0a1.018,1.018,0,0,0,0-2.035Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.29,29.224a1.77,1.77,0,0,1-.606-.107L3.96,23.042A1.781,1.781,0,0,1,2.9,20.758L9.027,3.943a1.784,1.784,0,0,1,2.281-1.064L28.032,8.954A1.781,1.781,0,0,1,29.1,11.238L28.565,12.7a.326.326,0,0,1-.554.1,4.376,4.376,0,0,0-3.332-1.515,4.259,4.259,0,0,0-4.325,4.18,4.259,4.259,0,0,0,4.325,4.18,4.492,4.492,0,0,0,.856-.082.326.326,0,0,1,.369.432l-2.939,8.06A1.785,1.785,0,0,1,21.29,29.224ZM10.7,3.135a1.42,1.42,0,0,0-1.333.932L3.237,20.883A1.417,1.417,0,0,0,4.084,22.7l16.724,6.075a1.419,1.419,0,0,0,1.816-.847l2.917-8a4.86,4.86,0,0,1-.861.077,4.623,4.623,0,0,1-4.689-4.543A4.623,4.623,0,0,1,24.68,10.92a4.741,4.741,0,0,1,3.566,1.594l.51-1.4A1.417,1.417,0,0,0,27.908,9.3L11.184,3.22A1.411,1.411,0,0,0,10.7,3.135Z",
    style: {
      fill: "#6873cf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.173,15.463A4.436,4.436,0,0,1,24.68,11.1a4.557,4.557,0,0,1,3.47,1.579.144.144,0,0,0,.245-.046l.532-1.459a1.6,1.6,0,0,0-.956-2.051L11.247,3.05A1.6,1.6,0,0,0,9.2,4L3.066,20.82a1.6,1.6,0,0,0,.956,2.051l16.724,6.075a1.6,1.6,0,0,0,2.049-.955l2.939-8.06a.145.145,0,0,0-.163-.192,4.664,4.664,0,0,1-.891.086A4.436,4.436,0,0,1,20.173,15.463Z",
    style: {
      fill: "url(#a)"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.715,
    y: 16.2,
    width: 1.163,
    height: 1.649,
    transform: "translate(0.591 34.994) rotate(-64)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhpunit);
export default __webpack_public_path__ + "static/media/phpunit.82790851be5ffe57d1461bc02870c799.svg";
export { ForwardRef as ReactComponent };